import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet, Navigate, useLocation } from 'react-router';
import { useStore } from '@link/supplier/stores';

const PrivateRoute = () => {
  const { timeZone, auth, backend } = useStore();
  const location = useLocation();

  useEffect(() => {
    if (!auth.loading && (auth.isAdmin || auth.isLinkAdmin)) {
      backend.listBackends();
      timeZone.getTimeZones();
    }
  }, [auth.loading, auth.isAdmin, auth.isLinkAdmin, backend, timeZone]);

  if (auth.loggedIn) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
};
const ObserverPrivateRoute = observer(PrivateRoute);
export default ObserverPrivateRoute;
